<template>
  <div>
    <button
      v-for="notification in notifications"
      :key="notification.id"
      @click="$emit('select', notification)"
      class="w-full flex items-start gap-3 px-4 py-3 text-left border-b border-slate-50 dark:border-zinc-800/60 last:border-0
             hover:bg-slate-50 dark:hover:bg-zinc-800/60 transition-colors duration-150"
      :class="!notification.read_at ? 'bg-primary-50/50 dark:bg-primary-950/10' : ''"
    >
      <span
        class="mt-1 w-2 h-2 rounded-full flex-shrink-0"
        :class="notification.read_at ? 'bg-transparent' : severityDotClass(notification.severity)"
      />
      <span class="min-w-0 flex-1">
        <span class="flex items-center justify-between gap-2">
          <span class="text-sm font-semibold text-zinc-800 dark:text-zinc-100 truncate">{{ notification.title }}</span>
          <span class="text-[11px] text-slate-400 dark:text-zinc-500 flex-shrink-0">{{ relativeTime(notification.created_at) }}</span>
        </span>
        <span class="block text-xs text-slate-500 dark:text-zinc-400 mt-0.5 leading-relaxed line-clamp-2">{{ notification.message }}</span>
      </span>
    </button>

    <div v-if="!notifications.length" class="px-4 py-10 text-center">
      <p class="text-sm text-slate-400 dark:text-zinc-500">Nenhuma notificação por aqui.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatDistanceToNow, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export interface NotificationApiItem {
  id: number
  severity: 'info' | 'warning' | 'success'
  title: string
  message: string
  link: string | null
  read_at: string | null
  created_at: string
}

defineProps<{ notifications: NotificationApiItem[] }>()
defineEmits<{ select: [notification: NotificationApiItem] }>()

const severityDotClass = (severity: NotificationApiItem['severity']) => ({
  info: 'bg-primary-500',
  warning: 'bg-warning-500',
  success: 'bg-success-500',
}[severity])

const relativeTime = (createdAt: string) =>
  formatDistanceToNow(parseISO(createdAt), { locale: ptBR, addSuffix: false })
</script>
